import { render, staticRenderFns } from "./ClinicAiAssistant.vue?vue&type=template&id=0d8adf32"
import script from "./ClinicAiAssistant.vue?vue&type=script&lang=js"
export * from "./ClinicAiAssistant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports